export const RUN_USER_LOGIN 	 							 =        		'RUN_USER_LOGIN'
export const RUN_USER_LOGIN_2FA 	 						 =        		'RUN_USER_LOGIN_2FA'
export const RUN_USER_SIGNUP 	 							 =        		'RUN_USER_SIGNUP'
export const RUN_STATE_LOAD 	 							 = 		  		'RUN_STATE_LOAD'
export const RUN_VERIFY_LEAD_OTP 	 						 =        		'RUN_VERIFY_LEAD_OTP'
export const RUN_USER_FORGOT_PASSWORD 	 					 =        		'RUN_USER_FORGOT_PASSWORD'
export const RUN_USER_RESET_PASSWORD_FROM_HASH 	 			 =        		'RUN_USER_RESET_PASSWORD_FROM_HASH'
export const RUN_CHANGE_PASSWORD 							 = 				'RUN_CHANGE_PASSWORD'

export const RUN_USER_LOGOUT 	 							 = 		  		'RUN_USER_LOGOUT'
export const RUN_GET_USER_IP 	 							 = 		  		'RUN_GET_USER_IP'
export const RUN_GENERATE_2FA_QRCODE	 					 = 		  		'RUN_GENERATE_2FA_QRCODE'
export const RUN_VERIFY_2FA_QRCODE	 					 	 = 		  		'RUN_VERIFY_2FA_QRCODE'
export const RUN_DISABLE_2FA_QRCODE	 					 	 = 		  		'RUN_DISABLE_2FA_QRCODE'
export const SAVE_FIREBASE_TOKEN							 =				'SAVE_FIREBASE_TOKEN'

export const RUN_SAVE_USER_NAME		 	  			         = 		  		'RUN_SAVE_USER_NAME'
export const RUN_REGISTER_STEP1		 	  			         = 		  		'RUN_REGISTER_STEP1'
export const RUN_REGISTER_STEP2		 	  			         = 		  		'RUN_REGISTER_STEP2'
export const RUN_REGISTER_STEP3		 	  			         = 		  		'RUN_REGISTER_STEP3'
export const RUN_REGISTER_STEP_TMA		 	  			     = 		  		'RUN_REGISTER_STEP_TMA'
export const SET_RISK_WARNING_POPUP 						 = 				"SET_RISK_WARNING_POPUP"
export const RUN_REGISTER_STEP4		 	  			         = 		  		'RUN_REGISTER_STEP4'
export const RUN_REGISTER_STEP5		 	  			         = 		  		'RUN_REGISTER_STEP5'
export const RUN_SKIP_DOCUMENT_UPLOAD		 	  			 = 		  		'RUN_SKIP_DOCUMENT_UPLOAD'
export const RUN_GET_SUM_SUB_RESPONSE		 	  			 = 		  		'RUN_GET_SUM_SUB_RESPONSE'
export const RUN_GET_QUESTION_ANSWER		 	  			 = 		  		'RUN_GET_QUESTION_ANSWER'
export const RUN_GET_QUESTION_ANSWER_TMA		             =              'RUN_GET_QUESTION_ANSWER_TMA'
export const RUN_TMA_USER_RESPONSE		                     =              'RUN_TMA_USER_RESPONSE'

export const RUN_RESOLVE_DOC_ISSUE		 	  			 	 = 		  		'RUN_RESOLVE_DOC_ISSUE'
export const RUN_DELETE_DOC		 	  			 	         = 		  		'RUN_DELETE_DOC'

/* ************** getters ***********************/
export const GET_INFO 										 = 				'GET_INFO'
export const GET_TOKEN 										 = 				'GET_TOKEN'
export const GET_USER 										 = 				'GET_USER'
export const GET_LOADERS									 = 				'GET_LOADERS'
export const GET_USER_LIST 									 = 				'GET_USER_LIST'
export const GET_QUESTIONS 									 = 				'GET_QUESTIONS'


/* ************** mutations - setters ***********************/
export const SET_INFO 										 = 				'SET_INFO'
export const SET_STATE 										 = 				'SET_STATE'
export const SET_STATE_PERSIST_LOCAL 						 = 				'SET_STATE_PERSIST_LOCAL'
export const SET_TOGGLE_LOADER 								 = 				'SET_TOGGLE_LOADER'
export const SET_STATE_USER_LIST 						     = 				"SET_STATE_USER_LIST"
export const SET_QUESTIONS 									 = 				"SET_QUESTIONS"




// WEBPACK FOOTER //
// ./src/types.js